// components/PostDetail.js

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPost } from '../actions/blogActions';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet'; // Import Helmet za meta tagove
import styles from './PostDetail.module.css';
import BlogTestimonials from './Blog/BlogTestimonials';

const PostDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  // Pristupanje pojedinačnom postu, loading statusu i grešci iz stanja
  const post = useSelector((state) => state.post.post);
  const loading = useSelector((state) => state.post.loading);
  const error = useSelector((state) => state.post.error);

  useEffect(() => {
    dispatch(fetchPost(id)); // Učitavanje pojedinačnog posta po ID-u
  }, [dispatch, id]);

  // Meta Pixel ViewContent event
  useEffect(() => {
    if (!post) return; // provera da li je post učitan

    let marketingConsent = false;
    try {
      const consentRaw = localStorage.getItem("cof_cookie_consent_v1");
      const consent = JSON.parse(consentRaw);
      marketingConsent = consent?.marketing === true;
    } catch {}

    if (marketingConsent && window.fbq) {
      window.fbq("track", "ViewContent", {
        content_name: post.title.rendered,
        content_category: post.categories?.join(",") || "Blog",
        content_ids: [post.id],
        url: window.location.href
      });
    }
  }, [post]);


  if (loading) return (
    <div className={styles.postDetail}>
      <div className={styles.loading}>Učitavanje...</div>
    </div>
  );

  if (error) return (
    <div className={styles.postDetail}>
      <div className={styles.error}>Došlo je do greške: {error}</div>
    </div>
  );

  return (
    <div className={styles.postDetail}>
      {post ? (
        <>
          <Helmet>
            <title>{post.title.rendered}</title>
            <meta property="og:title" content={post.title.rendered} />
            <meta property="og:description" content={post.excerpt.rendered} />
            <meta property="og:url" content={`https://conciergeoffootball.com/post/${id}`} />
            <meta property="og:type" content="article" />
            <meta property="og:site_name" content="Concierge of Football" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={post.title.rendered} />
            <meta name="twitter:description" content={post.excerpt.rendered} />
          </Helmet>

          <article className={styles.articleContainer}>
            <h1 className={styles.title}>{post.title.rendered}</h1>
            <div className={styles.text} dangerouslySetInnerHTML={{ __html: post.content.rendered }}></div>

            <div className={styles.postMeta}>
              <span>
                <i className="far fa-calendar-alt"></i>
                {new Date(post.date).toLocaleDateString('sr-RS', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </span>
              <span>
                <i className="far fa-clock"></i>
                {Math.ceil(post.content.rendered.replace(/<[^>]*>/g, '').split(' ').length / 200)} min čitanja
              </span>
              {post.author && (
                <span>
                  <i className="far fa-user"></i>
                  Autor: CoF Tim
                </span>
              )}
            </div>
          </article>
        </>
      ) : (
        <div className={styles.error}>Post nije pronađen.</div>
      )}
      <BlogTestimonials />
    </div>
  );
};

export default PostDetail;
